import { create } from "zustand";

/**
 * Ephemeral UI state for the cookie-consent banner. Not a source of truth —
 * the actual consent lives in the `tfc_consent` cookie (see `app/lib/consent.ts`).
 * `isOpen` is the PREFERENCES DIALOG (T872 S9): the first-visit banner opens it, and the
 * footer's and the profile's «Preferencias de cookies» re-open it after a choice (T35).
 * The banner itself is the component's own state — it shows only while no consent exists.
 */
interface ConsentUiState {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

export const useConsentStore = create<ConsentUiState>((set) => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
}));
